const RELEASE = true

const WX_HOST = 'http://weixinapi-test.cvddr.com'
const ZBZ_HOST = 'http://autismapi-test.heartme.cn'
const JX_HOST = 'http://jxapi-test.cvddr.cn'
const LDY_HOST = 'http://ldyapi-test.healxin.com'
const TOP_HOST = 'http://api-test.health-joy.net'
const GJ_HOST = 'http://guojiangapi-test.itopone.com'

function convertHost(host) {
  if (RELEASE) {
    return host.replace("-test.", ".")
  } else {
    return host
  }
}
module.exports = {
  WX_HOST: convertHost(WX_HOST),
  ZBZ_HOST: convertHost(ZBZ_HOST),
  JX_HOST: convertHost(JX_HOST),
  LDY_HOST: convertHost(LDY_HOST),
  TOP_HOST: convertHost(TOP_HOST),
  GJ_HOST: convertHost(GJ_HOST)
}



//////////////////
// WEBPACK FOOTER
// ./config/hosts.js
// module id = a1Hi
// module chunks = 2